import { useState } from 'react';
import { Modal, Button, Loader, Message } from 'semantic-ui-react';
import request from '../utils/request';

export default () => {
  const [open, setOpen] = useState(false);
  const [error, setError] = useState();
  const [success, setSuccess] = useState();
  const [clearingDBCache, setClearingDBCache] = useState(false);

  async function triggerClearDBCache() {
    setClearingDBCache(true);
    setSuccess(null);
    setError(null);
    const response = await request('post', process.env.REACT_APP_EXPRESS_URL + 'refreshTables');
    if (response.error) {
      setError('Error clearing DB cache: ' + response.errorMessage);
    } else {
      setSuccess('Succesfully cleared DB cache. If you need to run this again, refresh the page.');
    }
    setClearingDBCache(false);
  }

  return (
    <Modal
      closeIcon
      onClose={() => setOpen(false)}
      onOpen={() => setOpen(true)}
      open={open}
      trigger={<Button primary content="Clear DB Cache?" />}
    >
      <Modal.Header>Clear database cache</Modal.Header>
      <Modal.Content>
        <Loader active={clearingDBCache} />
        <Message>This will trigger the database cache to be cleared which is helpful if you recently made a bigger change like starting a new season or changed a team's city.</Message>
        {error ? <Message
          error
          content={error}
        /> : null}
        {success ? <Message
          content={success}
        /> : null}
      </Modal.Content>
      <Modal.Actions>
        <Button
          positive
          disabled={clearingDBCache || success}
          content="Are you sure that you want to cache the database cache"
          onClick={triggerClearDBCache}
        />
      </Modal.Actions>
    </Modal>
  );
};
